
define('template!webshopMenuLocaleView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="mm-modal-text">' +
((__t = ( _.i18n('webshop.menu.copyHelp', null, 'The menu of this language replaces the one in the editor (nothing is published before "Save and publish"). The names stay in the copied language: translate them.') )) == null ? '' : __t) +
'</div>\n<select class="mm-copy-locale">\n    ';
 _.each(locales, function (l) { ;
__p += '\n    <option value="' +
__e( l.locale ) +
'" ';
 if (l.locale === locale) { ;
__p += 'selected';
 } ;
__p += '>' +
__e( l.locale.toUpperCase() ) +
'</option>\n    ';
 }); ;
__p += '\n</select>\n';

}
return __p
};});

